import Vue from 'vue'
import gsap from 'gsap'
// import ScrollTrigger from 'gsap/ScrollTrigger'

// gsap.registerPlugin(ScrollTrigger)

export default Vue.mixin({
    created: function() {
        this.gsap = gsap
    }
})
